import { render } from "./UserKatmanButtonSvg.vue?vue&type=template&id=1309322b"
import script from "./UserKatmanButtonSvg.vue?vue&type=script&lang=js"
export * from "./UserKatmanButtonSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__